export default "__VITE_ASSET__fx3eCzqu__"